export const SUCCESS_TEXT = {
  created: "created",
  deleted: "deleted",
  edited: "edited",
};
